module.exports = __webpack_public_path__ + "static/media/dslogon-icon.935312e0.svg";